import { Appointment } from '~/types/tutoring-api'
import { formatAsDay } from '~/utils/time'

export function getAppointmentsForDate(appointments: Appointment[], date: Date): Appointment[] {
  return appointments.filter((elem) => {
    return new Date(elem.startTime).getDate() === date.getDate()
  })
}

export function getAppointmentsFromDate(appointments: Appointment[], date: Date): Appointment[] {
  return appointments.filter((elem) => {
    return new Date(elem.startTime).getDate() >= date.getDate()
  })
}

export function getDatesWithAppointments(appointments: Appointment[], timezone: string): string[] {
  return appointments.map((elem) => {
    return formatAsDay(new Date(elem.startTime), timezone)
  })
}
